// extracted by mini-css-extract-plugin
export default {"copy_right_box":"Copyright_copy_right_box__qEGdO","copy_right":"Copyright_copy_right__GbQ2q"};